export enum EntityType {
  Attachment = 0,
  Communication = 1,
  Category = 2,
  Customer = 3,
  Job = 4,
  Task = 5,
  SubTask = 6,
  PaymentLinkTemplate = 7,
  Snippet = 8,
  Appointment = 9,
  Document = 10,
  Comment = 11
}
